import React, { useContext, useEffect } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { DispatchContext } from 'store/contexts'
import { START_QUERY } from 'api/queries'
import {
  GO_TO_QUESTIONS_SCREEN,
  SET_QUESTIONS,
  GENERATE_INITIAL_RESPONSES,
  SET_PRODUCTS,
  ADD_UI_STATE,
} from 'store/actions'
import { IQuestion, IProduct, IContentConfig } from 'models'
import { Flex, Icon } from 'components'

interface IQueryData {
  questions: IQuestion[]
  products: IProduct[]
  contentConfig: IContentConfig
}

const StartScreen = () => {
  const dispatch = useContext(DispatchContext)
  const { loading, error, data } = useQuery<IQueryData>(START_QUERY)

  const questions = data?.questions
  const products = data?.products
  const contentConfig = data?.contentConfig

  useEffect(() => {
    if (questions) {
      dispatch({ type: SET_QUESTIONS, payload: questions })
      dispatch({ type: GENERATE_INITIAL_RESPONSES, payload: questions })
      dispatch({ type: GO_TO_QUESTIONS_SCREEN })
    }
  }, [questions, dispatch])

  useEffect(() => {
    if (products) {
      dispatch({ type: SET_PRODUCTS, payload: { products } })
    }
  }, [products, dispatch])

  useEffect(() => {
    if (contentConfig) {
      dispatch({ type: ADD_UI_STATE, payload: { contentConfig } })
    }
  }, [contentConfig, dispatch])

  // TODO: better error state
  if (error) return <p>Error :(</p>

  return (
    <>
      {loading && (
        <Flex>
          <Icon name='loader' color='white' size='42px' viewBox='100' />
        </Flex>
      )}
    </>
  )
}

export default StartScreen
